var map = {
	"./bio-gr-vertical.png": 113,
	"./bio-gr.png": 7961,
	"./bio-gr1.png": 5263,
	"./contemplative-reptile.jpg": 7842,
	"./home-foto.png": 8052,
	"./logo-horizontal.png": 7723,
	"./logo-icon.png": 197,
	"./logo-outlined-icon.png": 689,
	"./logo.png": 4427,
	"./service-1.png": 992,
	"./service-2.png": 9508,
	"./service-3.png": 1307,
	"./service-4.png": 3697
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 990;